import styled from 'styled-components';

export const BlogPost = styled.article``;
